const inputField = document.querySelectorAll('.form-file_field');
const inputBtn = document.querySelectorAll('.form-file_btn-input');
const fileInput = document.getElementById('file-input');
const forms = document.querySelectorAll('.contact-form');

function getFileName(file, max = 43, start = 30, end = 8) {
  let fileName = file.name;

  if (fileName.length > max) {
    const startString = file.name.substring(0, start);
    const endString = file.name.substring(file.name.length - end);
    fileName = `${startString}...${endString}`;
  }

  return fileName;
}
function addFiles(parent) {
  const files = this.files;
  parent.classList.add('js-active');

  for (let fileKey = 0; fileKey < files.length; fileKey++) {
    const shortName = getFileName(files[fileKey], 35, 15);
    const name = files[fileKey]?.name;

    if (!shortName) return;

    const newElement = document.createElement('div');
    newElement.id = name;
    newElement.className = 'file-text';
    newElement.innerHTML = `
          <span class="icon-paperlip"></span>
          <span class="form-file_btn__text">${shortName}</span>
          <span data-name="${name}" class="icon-remove"></span>
        `;
    parent.append(newElement);
    removeFile.call(this, newElement, name);
  }
}

function removeFile(removedElement, name) {
  const files = this.files;
  const removeBtnElement = document.getElementById(name);

  removeBtnElement.addEventListener('click', function (event) {
    if (!event.target.classList.contains('icon-remove')) return;

    const fileElements = document.querySelectorAll('.dnd-upload-details');

    fileElements.forEach(item => {
      const fileName = item.querySelector('.name span').innerHTML;
      const isRemovedElement = name === fileName;

      if (isRemovedElement) {
        item.querySelector('.remove-file span').click();
        removedElement.remove();
      }
    });
  });
}

if (inputField.length) {
  inputField.forEach((element) => {
    element.addEventListener('change', function () {
      this.closest('.form-file').querySelector('.form-file__text').innerHTML = getFileName(this.files[0]);
    });
  });
}

if (inputBtn.length) {
  inputBtn.forEach((element) => {
    element.addEventListener('change', function () {
      const parentElement = this.closest('.form-group').querySelector('.form-file_btn__info');
      const fileElements = document.querySelectorAll('.file-text');

      parentElement.classList.remove('js-active');

      fileElements?.forEach(item => item.remove());

      addFiles.call(this, parentElement);
    });
  });
}

if (forms?.length) {
  forms.forEach(form => {
    form.addEventListener('wpcf7mailsent', () => {
      const fileElements = form.querySelectorAll('.file-text');
      fileElements?.forEach(item => item.remove());
    });
  });
}

if (fileInput) {
  fileInput.addEventListener('click', function() {
    inputBtn[0].click();
  });
}
